<template>
  <section class="employees">
    <div class="card-actions card">
      <div class="card-content">
        <div class="content flex md:flex-row flex-col space-y-4 md:space-y-0">
          <h1 class="title">
            Manage your contributors
          </h1>
          <button
            class="button primary"
            @click="showAddEditModal()"
          >
            Add a collaborator
          </button>
        </div>
      </div>
    </div>
    <br>
    <div class="columns">
      <div class="column is-12 is-paddingless">
        <br>
        <div class="grid_employee">
          <div
            v-for="(employee, idx_employee) in employees"
            :key="'emp_' + idx_employee"
            class="row"
          >
            <div class="card">
              <header class="card-header">
                <div class="card-header-title is-primary-border">
                  <span class="employee-name">
                    {{ getEmployeeName(employee) }}
                  </span>
                  <div>
                    <span>
                      {{ employee.email }}
                    </span>
                    <span>
                      Manager
                    </span>
                  </div>
                </div>
                <div class="card-header-icon">
                  <div
                    class="dropdown"
                    :class="{'is-active': employee.show_menu}"
                  >
                    <div class="dropdown-trigger">
                      <button
                        v-if="employee.uuid !== $store.state.user.uuid"
                        class="button is-white"
                        aria-haspopup="true"
                        aria-controls="dropdown-menu"
                        @click="employee.show_menu = !employee.show_menu"
                      >
                        <span class="icon is-small">
                          <i
                            class="fas fa-ellipsis-v"
                            aria-hidden="true"
                          />
                        </span>
                      </button>
                      <a
                        v-else
                        class="button is-white has-tooltip-bottom has-tooltip-arrow"
                        href="user/profile"
                        data-tooltip="Edit your profile"
                      >
                        <span class="icon is-small">
                          <i class="far fa-user" />
                        </span>
                      </a>
                    </div>
                    <div
                      v-if="employee.uuid !== $store.state.user.uuid"
                      id="dropdown-menu"
                      class="dropdown-menu"
                      role="menu"
                    >
                      <div class="dropdown-content">
                        <button
                          class="dropdown-item"
                          @click="showEditModal(employee)"
                        >
                          Edit
                        </button>
                        <button
                          class="dropdown-item"
                          @click="showDeleteModal(employee.uuid, idx_employee)"
                        >
                          Remove
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </header>
              <div class="card-content">
                <div
                  v-for="(location, idx_location) in employee.locations"
                  :key="'emp_' + idx_location"
                  class="content"
                >
                  <div>
                    <img
                      src="../../../public/assets/img/location.svg"
                      alt="Location"
                    >
                    <p class="location-name">
                      {{ location.name }}
                    </p>
                  </div>
                  <div>
                    {{ getCompanyAddress(location) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal add-employee"
      :class="{'is-active' : show_modal_add_edit}"
    >
      <div
        class="modal-background"
        @click="hideAddModal()"
      />
      <div class="modal-content">
        <div
          v-if="isLoading"
          class="flex justify-center items-center"
        >
          <span class="animate-spin rounded-full border-t-4 border-b-4 border-blue-500 h-6 w-6" />
        </div>
        <div
          v-if="!isLoading"
          class="box"
        >
          <p class="title">
            {{ isEditMode ? 'Edit' : 'Add' }} collaborator
          </p>
          <p
            v-if="!isEditMode"
            class="sub-title"
          >
            Add new team member to your company
          </p>
          <div class="employee-info is-fullwidth">
            <div class="field">
              <div class="control">
                <label class="label">
                  <span>Email</span>
                  <span
                    :data-tooltip="'Required field' + '\n' + 'Allowed character count is 100' + '\n' + 'Should be valid'"
                    class="tooltip has-tooltip-right has-tooltip-arrow"
                  >
                    <img
                      src="../../../public/assets/img/info.svg"
                      alt=""
                    >
                  </span>
                </label>
                <input
                  ref="email"
                  v-model="email"
                  class="input is-mandatory"
                  :class="errors.email.visible ? 'has-error'
                    : ''"
                  :disabled="isEditMode"
                  type="text"
                  placeholder="Email address: example@storage.com"
                >
                <span v-if="errors.email.visible">{{ errors.email.message }}</span>
              </div>
            </div>
          </div>
          <div
            v-if="locations.length"
            class="field employee-locations"
          >
            <div class="control">
              <label class="label">
                <span>Set roles in locations</span>
                <span
                  :data-tooltip="'Required field'"
                  class="tooltip has-tooltip-right has-tooltip-arrow"
                >
                  <img
                    src="../../../public/assets/img/info.svg"
                    alt=""
                  >
                </span>
              </label>

              <div class="locations is-fullwidth">
                <div
                  v-for="(location) in locations"
                  :key="location.uuid"
                  class="location"
                >
                  <input
                    :id="'location-' + location.uuid"
                    v-model="location.checked"
                    type="checkbox"
                    :checked="location.checked"
                    :value="location.uuid"
                  >
                  <label :for="'location-' + location.uuid">{{ location.name }}</label>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <no-location :handle-add="handleAddClick" />
          </div>
          <div
            v-if="isUserSuperAdmin && isEditMode"
            class="field employee-locations"
          >
            <span
              class="label"
              style="margin-bottom: 15px"
            >
              Access Control
            </span>
            <div class="control locations">
              <div class="location is-fullwidth">
                <input
                  id="placeHold"
                  v-model="accessControl.placeHold"
                  type="checkbox"
                  value="place_hold"
                >
                <label for="placeHold">Place Hold</label>
              </div>
            </div>
            <div class="control locations">
              <div class="location is-fullwidth">
                <input
                  id="requestHold"
                  v-model="accessControl.requestHold"
                  type="checkbox"
                  value="request_hold"
                >
                <label for="requestHold">Request Hold Release</label>
              </div>
            </div>
            <div class="control locations">
              <div class="location is-fullwidth">
                <input
                  id="approveHold"
                  v-model="accessControl.approveHold"
                  type="checkbox"
                  value="approve_hold"
                >
                <label for="approveHold">Approve Hold Release</label>
              </div>
            </div>
            <!-- Alt Address -->
            <div class="control locations">
              <div class="location is-fullwidth">
                <input
                  id="addAlternate"
                  v-model="accessControl.addAlternate"
                  type="checkbox"
                  value="approve_hold"
                >
                <label for="addAlternate">Add alternate address</label>
              </div>
            </div>
            <div class="control locations">
              <div class="location is-fullwidth">
                <input
                  id="editAlternate"
                  v-model="accessControl.editAlternate"
                  type="checkbox"
                  value="approve_hold"
                >
                <label for="editAlternate">Edit alternate address</label>
              </div>
            </div>
            <div class="control locations">
              <div class="location is-fullwidth">
                <input
                  id="deleteAlternate"
                  v-model="accessControl.deleteAlternate"
                  type="checkbox"
                  value="approve_hold"
                >
                <label for="deleteAlternate">Delete alternate address</label>
              </div>
            </div>
          </div>
          <div class="control">
            <button
              type="button"
              class="button is-outlined"
              @click="hideAddModal()"
            >
              Cancel
            </button>
            <button
              type="button"
              class="button primary"
              @click="addEditEmployee()"
            >
              {{ isEditMode ? 'Save' : 'Add' }}
            </button>
          </div>
        </div>
      </div>
      <button
        class="modal-close is-large"
        aria-label="close"
        @click="hideAddModal()"
      />
    </div>
    <div
      class="modal"
      :class="{'is-active' : show_modal_delete}"
    >
      <div
        class="modal-background"
        @click="hideDeleteModal()"
      />
      <div class="modal-content">
        <div class="box">
          <h6>Remove this collaborator?</h6>
          <p>This user won't access to company's data anymore. This action can't be undone</p>
          <p
            class="control has-text-right"
            style="margin-top: 2rem"
          >
            <a
              href="#"
              class="button is-white"
              @click="hideDeleteModal()"
            >Cancel</a>
            <a
              href="#"
              class="button is-danger is-outlined"
              @click="setDelete(uuid_delete)"
            >Confirm</a>
          </p>
        </div>
      </div>
      <button
        class="modal-close is-large"
        aria-label="close"
        @click="hideDeleteModal()"
      />
    </div>
  </section>
</template>
<script>
import NoLocation from '../location/NoLocation';
import { Roles } from '@/constants';
import { isValidEmail } from '@/utils/validationUtils';
import UserService from '../../services/user.service';

const userService = new UserService();

const defaultErrors = {
  email: {
    visible: false,
    message: ''
  }
};
const defaultAccessControl = {
  placeHold: false,
  requestHold: false,
  approveHold: false,
  addAlternate: false,
  editAlternate: false,
  deleteAlternate: false
};
export default {
  name: 'ManagersComponent',
  components: {
    NoLocation
  },
  data() {
    return {
      locations: [],
      employees: [],
      show_modal_add_edit: false,
      show_modal_delete: false,
      uuid_delete: '',
      current_idx_company_for_edited_employee: '',
      roles: Roles,
      role: this.$store.state.user.role,
      assignedLocation: null,
      selectedCompany: null,
      isEditMode: false,
      selectedOrganizationUuid: null,
      accessControl: defaultAccessControl,
      isLoading: false,
      email: '',
      errors: { ...defaultErrors }
    };
  },
  computed: {
    isUserSuperAdmin() {
      return this.role === this.roles.SUPER_ADMIN;
    }
  },
  mounted() {
    const { state } = this.$store;
    // eslint-disable-next-line no-nested-ternary, no-use-before-define
    const organization = state.selectedOrganization && Object.keys(state.selectedOrganization).length ? state.selectedOrganization : state.organization && Object.keys(state.organization).length ? organization : {};
    this.selectedOrganizationUuid = organization && Object.keys(organization).length ? organization.uuid : '';
    this.getEmployee();
    this.getLocations();
  },
  methods: {
    getEmployee() {
      const self = this;
      const { state } = this.$store;
      const selectedOrganization = { ...state.selectedOrganization };
      const currentOrganization = !this.activateMode && selectedOrganization && Object.keys(selectedOrganization).length ? selectedOrganization : {};
      const selectedOrganizationUuid = currentOrganization && Object.keys(currentOrganization).length ? currentOrganization.uuid : '';
      userService.getEmployees(selectedOrganizationUuid)
        .then((response) => {
          const { status, result } = response.data;

          if (status === 'success') {
            const tmp = result.map((it) => ({ ...it, show_menu: false }));
            self.employees = [...tmp];
          } else {
            self.$root.$emit('showToast', { message: 'Impossible to perform this action. Be sure to be connected and to have access to this action', options: { cssClass: 'is-danger', duration: 10000 } });
          }
        })
        .catch(() => {
          self.$root.$emit('showToast', { message: 'Impossible to perform this action. Be sure to be connected and to have access to this action', options: { cssClass: 'is-danger', duration: 10000 } });
        });
    },
    async getUserAccess(id) {
      try {
        this.isLoading = true;
        const resp = await userService.getUserHoldPermissions(id);
        const { data } = resp;

        switch (data.status) {
          case 'success':
            data.result.forEach((it) => {
              switch (it.slug) {
                case 'place_hold':
                  this.accessControl.placeHold = !!it.has_permission;
                  break;
                case 'request_hold':
                  this.accessControl.requestHold = !!it.has_permission;
                  break;
                case 'release_hold':
                  this.accessControl.approveHold = !!it.has_permission;
                  break;
                case 'add_alternate':
                  this.accessControl.addAlternate = !!it.has_permission;
                  break;
                case 'edit_alternate':
                  this.accessControl.editAlternate = !!it.has_permission;
                  break;
                case 'delete_alternate':
                  this.accessControl.deleteAlternate = !!it.has_permission;
                  break;
                default:
                  break;
              }
            });
            break;
          default:
            this.$root.$emit('showToast', {
              message: 'Impossible to find your permissions. Please try later',
              options: { cssClass: 'is-danger', duration: 10000 }
            });
            break;
        }
      } catch (error) {
        this.$root.$emit('showToast', {
          message: 'Impossible to find your permissions. Please try later',
          options: { cssClass: 'is-danger', duration: 10000 }
        });
      } finally {
        this.isLoading = false;
      }
    },
    getLocations() {
      const self = this;

      userService.getLocations(this.$store.state.user.role, this.selectedOrganizationUuid)
        .then((resp) => {
          const locationsData = resp.data;
          const { status: locationStatus } = locationsData;

          if (locationStatus === 'success') {
            self.locations = locationsData.result.map((location) => ({ ...location, show_menu: false }));
          } else {
            self.$root.$emit('showToast', {
              message: 'Impossible to find your location info. Please try later or complete your profile',
              options: { cssClass: 'is-danger', duration: 10000 }
            });
          }
        })
        .catch(() => {
          self.$root.$emit('showToast', {
            message: 'Impossible to find your location info. Please try later or complete your profile',
            options: { cssClass: 'is-danger', duration: 10000 }
          });
        });
    },
    showAddEditModal() {
      this.show_modal_add_edit = true;
      const { selectedCompany } = this;
      if (selectedCompany && this.isEditMode) {
        this.getUserAccess(selectedCompany.uuid);
        this.email = selectedCompany.email;
        this.assignedLocation = selectedCompany.locations[0].uuid;
        this.locations = this.locations.map((location) => ({ ...location, checked: selectedCompany.locations.find((it) => it.uuid === location.uuid) }));
      }
    },
    hideAddModal() {
      this.show_modal_add_edit = false;
      this.isEditMode = false;
      this.selectedCompany = null;
      this.resetData();
    },
    addEditEmployee() {
      const self = this;
      const { accessControl, email } = this;
      const selectedLocations = this.locations.filter((location) => location.checked).map((it) => ({ uuid: it.uuid }));
      const { state } = this.$store;
      const selectedOrganization = { ...state.selectedOrganization };
      const currentOrganization = !this.activateMode && selectedOrganization && Object.keys(selectedOrganization).length ? selectedOrganization : {};
      const selectedOrganizationUuid = currentOrganization && Object.keys(currentOrganization).length ? currentOrganization.uuid : '';
      let message = '';
      const emailError = {
        visible: false,
        message: ''
      };

      if (!email) {
        message += 'Email is required <br >';
        emailError.visible = true;
        emailError.message = 'Email is required';
      } else if (!isValidEmail(email)) {
        message += 'Please provide a valid email <br >';
        emailError.visible = true;
        emailError.message = 'Please provide a valid email';
      } else if (email.length > 100) {
        message += 'Allowed character count is 100';
        emailError.visible = true;
        emailError.message = 'Allowed character count is 100';
      }

      if (!selectedLocations || !selectedLocations.length) {
        message += 'Location is required <br >';
      }

      this.errors = {
        ...this.errors,
        email: emailError
      };

      if (message.length) {
        this.$root.$emit('showToast', { message, options: { cssClass: 'is-danger', duration: 5000 } });
        return;
      }

      const data = {
        email,
        locations: selectedLocations
      };
      const accessData = {
        place_hold: Number(accessControl.placeHold),
        request_hold: Number(accessControl.requestHold),
        release_hold: Number(accessControl.approveHold)
      };

      let employeeAction = () => userService.addEmployee(selectedOrganizationUuid, data);

      if (this.isEditMode && this.isUserSuperAdmin) {
        employeeAction = () => userService.editEmployee(this.selectedCompany.uuid, data);
        userService.updateUserHoldPermissions(accessData, this.selectedCompany.uuid).then((res) => {
          if (res.data?.status === 'success') {
            self.$root.$emit('showToast', { message: message || 'Permissions updated', options: { cssClass: 'is-success', duration: 5000 } });
          } else {
            self.$root.$emit('showToast', { message, options: { cssClass: 'is-danger', duration: 10000 } });
          }
        });
      }

      employeeAction()
        .then((response) => {
          // eslint-disable-next-line no-shadow
          const { status, message, result: { message: editMessage } } = response.data;

          if (status === 'success') {
            self.getEmployee();
            self.hideAddModal();
            self.$root.$emit('showToast', { message: message || editMessage, options: { cssClass: 'is-success', duration: 5000 } });
          } else {
            self.$root.$emit('showToast', { message, options: { cssClass: 'is-danger', duration: 10000 } });
          }
        })
        .catch(() => {
          self.$root.$emit('showToast', { message: 'Impossible to perform this action. Be sure to be connected and to have access to this action', options: { cssClass: 'is-danger', duration: 10000 } });
        });
    },
    setDelete(uuid) {
      const self = this;

      userService.removeEmployee(uuid)
        .then((response) => {
          const { status, message } = response.data;

          if (status === 'success') {
            self.getEmployee();
            self.$root.$emit('showToast', { message, options: { cssClass: 'is-success', duration: 10000 } });
          } else {
            self.$root.$emit('showToast', { message, options: { cssClass: 'is-danger', duration: 10000 } });
          }
          self.hideDeleteModal();
        })
        .catch(() => {
          self.$root.$emit('showToast', { message: 'Impossible to perform this action. Be sure to be connected and to have access to this action', options: { cssClass: 'is-danger', duration: 10000 } });
          self.hideDeleteModal();
        });
    },
    showDeleteModal(uuid, idxCompany) {
      this.uuid_delete = uuid;
      this.show_modal_delete = true;
      this.current_idx_company_for_edited_employee = idxCompany;
    },
    showEditModal(company) {
      this.selectedCompany = company;
      this.isEditMode = true;
      this.showAddEditModal();
    },
    hideDeleteModal() {
      this.uuid_delete = '';
      this.show_modal_delete = false;
      this.current_idx_company_for_edited_employee = '';
    },
    getEmployeeName(user) {
      return [user.firstname, user.lastname].filter((it) => it).join(' ');
    },
    getCompanyAddress(company) {
      const {
        zipcode, address1, address2, city, state: { abbreviation }
      } = company;
      return [zipcode, address1, address2, city, abbreviation].filter((it) => it).join(', ');
    },
    resetData() {
      this.email = '';
      this.assignedLocation = null;
      this.locations = this.locations.map((location) => ({ ...location, checked: false }));
      this.errors = { ...defaultErrors };
      this.accessControl = defaultAccessControl;
    },
    handleAddClick() {
      this.$root.$emit('showAddLocation');
    }
  }
};
</script>
<style scoped src='../../../public/assets/css/bulma-extension/bulma-tooltip.min.css'></style>
<style scoped lang="scss">
  .employees {

      .is-borderless {
          border: 0;
      }

      .grid_employee {
          .row {
              margin-top: 10px;

              .card {
                  height: 100%;
                  display: flex;
                  flex-direction: column;

                  .card-header {
                      margin: 0;

                      .card-header-title {
                          display: flex;
                          border-left-width: 4px;
                          border-left-style: solid;
                          padding: 0 1rem;
                          font-weight: 400;

                          div {
                              display: flex;
                              justify-content: space-between;
                              width: 50%;
                          }

                          .employee-name {
                              width: 50%;
                          }
                      }

                      .card-header-icon {
                          max-width: 72px;

                          .dropdown-menu {
                              left: unset;
                              right: 0;
                          }
                      }
                  }

                  .card-content {
                      border-top: 1px solid #ededed;
                      padding: 1rem;

                      @apply
                        border-muted-200
                        dark:border-muted-600;

                      .content {
                          width: calc(100% - 72px);
                          display: flex;

                          div {
                              display: flex;
                              align-items: center;
                              width: 50%;

                              img {
                                  width: 20px;
                                  height: 20px;
                              }

                              .location-name {
                                  margin-left: 10px
                              }
                          }
                      }
                  }
              }
          }
      }

      .card-actions {
          position: -webkit-sticky;
          position: sticky;
          top: 0;
          z-index: 2;

          .content {
              display: flex;
              justify-content: space-between;

              .title {
                  margin: 0;
              }
          }
      }

      .add-employee {
          .modal-content {
              width: 700px;

              .box {

                  .title {
                      font-size: 24px;
                      font-weight: bold;
                      margin: 0;
                  }

                  .sub-title {
                      font-size: 16px;
                      margin: 5px 0 10px;
                  }

                  .employee-info {
                      display: flex;
                      justify-content: space-between;
                      margin-top: 10px;

                      .field {
                          width: 100%;
                      }
                  }

                  .employee-locations {
                      margin: 25px 0;

                      .control {
                          h6 {
                              margin: 0;
                          }

                          .locations {
                              max-height: 400px;
                              margin-top: 10px;
                              overflow: auto;
                          }
                      }
                  }

                  .control {
                      display: flex;
                      justify-content: space-between;

                      .button {
                          width: 120px;
                      }
                  }
              }
          }
      }
  }
  .location {
      display: flex;
      align-items: center;
      padding: 15px;

      @apply
        border-b
        border-solid
        border-muted-200
        dark:border-muted-600;

        &:hover {
          @apply
            bg-muted-200
            dark:bg-muted-600;
        }

      input,
      label {
          cursor: pointer;
      }

      label {
          margin-left: 15px;
      }
  }
</style>
